//@ts-nocheck
import {Column} from 'react-table'
import {ProviderNameCell} from './ProviderNameCell'
// import {ProviderDocCell} from './ProviderDocCell'
// import {ProviderLastLoginCell} from './ProviderLastLoginCell'
// import {ProviderTwoStepsCell} from './ProviderTwoStepsCell'
// import {ProviderTelephoneCell} from './ProviderTelephoneCell'
// import {ProviderEmailCell} from './ProviderEmailCell'
//import {ProviderSelectionCell} from './ProviderSelectionCell'
import {ProviderCustomHeader} from './ProviderCustomHeader'
//import {ProviderSelectionHeader} from './ProviderSelectionHeader'
import {ProviderActionsCell} from './ProviderActionsCell'
import {Provider} from '../../core/_models'

const providerColumns: ReadonlyArray<Column<Provider>> = [
  {
    Header: (props) => (
      <ProviderCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <ProviderNameCell provider={props.data[props.row.index]} />,
  },
  // {
  //   Header: (props) => (
  //     <ProviderCustomHeader
  //       tableProps={props}
  //       title='COMMON.INPUT_CNPJ'
  //       className='text-right min-w-125px'
  //     />
  //   ),
  //   id: 'document',
  //   Cell: ({...props}) => <ProviderDocCell provider={props.data[props.row.index]} />,
  // },
  // {
  //   Header: (props) => (
  //     <ProviderCustomHeader
  //       tableProps={props}
  //       title='COMMON.INPUT_PHONE'
  //       className='text-right min-w-125px'
  //     />
  //   ),
  //   id: 'telephone',
  //   Cell: ({...props}) => <ProviderTelephoneCell provider={props.data[props.row.index]} />,
  // },
  // {
  //   Header: (props) => (
  //     <ProviderCustomHeader
  //       tableProps={props}
  //       title='COMMON.INPUT_EMAIL'
  //       className='text-right min-w-125px'
  //     />
  //   ),
  //   id: 'email',
  //   Cell: ({...props}) => <ProviderEmailCell provider={props.data[props.row.index]} />,
  // },
  {
    Header: (props) => (
      <ProviderCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ProviderActionsCell data={props.data[props.row.index]} />,
  },
]

export {providerColumns}
